import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router';
import { Card, Center, Large, Layout, Li, Ol, P, Pre, Spacer } from '../../shared/visualIdentity';
import GlobalWrapper from '../../shared/visualIdentity/GlobalWrapper';
import { H1, H3 } from '../../shared/visualIdentity/Headers';
import './components/browserBackground.scss';
import './components/shopShowcase.scss';

const WidgetAnnouncement = props => (
  <GlobalWrapper>
    <Layout>
      <Helmet>
        <title>Your clients can now book directly from your website!</title>
      </Helmet>

      <H1>Your clients can now book directly from your website!</H1>

      <div id="browser-background">
        <img
          src="https://assets.getsquire.com/widget-release-email/widget.gif"
          title="Squire booking widget in action"
          alt="Squire booking widget in action"
        />
      </div>

      <P>
        We want to introduce you to the Squire Booking Widget, the best place for your clients to book your barbershop,
        all without ever having to leave your website. Follow the steps below to install it today; it’ll only take a
        minute!
      </P>

      <H3>How do I get this?</H3>

      <Ol>
        <Li>Copy your widget code snippet below</Li>
        <Li>
          Paste the code within the <strong>{'<head></head>'}</strong> tags of your home page.
        </Li>
      </Ol>

      <Card>
        <P>
          <strong>Your code snippet:</strong>
        </P>

        <Pre>
          {`<script type="text/javascript"> !function(e,t){var i=e.createElement("script"),sa="setAttribute";i.src="https://widget.getsquire.com/widget.js?"+Date.now(),i[sa]("defer",""),i[sa]("type","text/javascript"),i[sa]("brand",t.brand),i[sa]("x-squire-inline-enabled",t.inline||!1),e.head.appendChild(i)}(document,{brand:"${props.params.brandId}",inline:true});</script>`}
        </Pre>
      </Card>

      <Spacer height="1rem" />

      <Large>
        <Center>
          <P>
            Squire supports your brand and we know you’ll love this new widget! <br />
            Check out some of our partners who are already using it.
          </P>
        </Center>
      </Large>

      <Center>
        <div id="shop-showcase">
          <a
            href="https://glassboxbarbershop.com/"
            target="_blank"
            rel="noopener noreferrer"
            title="Glassbox Barber Shop"
          >
            <img
              src="https://assets.getsquire.com/widget-release-email/shop1.png"
              srcSet="https://assets.getsquire.com/widget-release-email/shop1@2x.png 2x"
              alt="Glassbox logo"
              title="Glassbox logo"
              role="presentation"
            />
          </a>

          <a
            href="https://rosemontbarbershop.com/"
            target="_blank"
            rel="noopener noreferrer"
            title="Rosemont Barber Shop"
          >
            <img
              src="https://assets.getsquire.com/widget-release-email/shop2.png"
              srcSet="https://assets.getsquire.com/widget-release-email/shop2@2x.png 2x"
              alt="Rosemont logo"
              title="Rosemont logo"
              role="presentation"
            />
          </a>

          <a
            href="https://thespotbarbershop.com/"
            target="_blank"
            rel="noopener noreferrer"
            title="The Spot Barber Shop"
          >
            <img
              src="https://assets.getsquire.com/widget-release-email/shop3.png"
              srcSet="https://assets.getsquire.com/widget-release-email/shop3@2x.png 2x"
              alt="The spot logo"
              title="The spot logo"
              role="presentation"
            />
          </a>
        </div>
      </Center>
    </Layout>
  </GlobalWrapper>
);

WidgetAnnouncement.propTypes = {
  params: PropTypes.shape({
    brandId: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(WidgetAnnouncement);



// WEBPACK FOOTER //
// ./src/app/notifications/announcements/WidgetAnnouncement/index.jsx